// extracted by css-extract-rspack-plugin
export default {"root":"KJZafn","content-root":"RABQ3a","contentRoot":"RABQ3a"};